import { render, staticRenderFns } from "./IMEFPolitics.vue?vue&type=template&id=6e7f4f78"
import script from "./IMEFPolitics.vue?vue&type=script&lang=js"
export * from "./IMEFPolitics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports